// Types
import { AppDispatch, AppGetState } from 'types/RootState.types';

// Config
import { CARD_DETAILS_FORM_ID } from '@utils/form/configs/cardDetails';
import { sendNewRelicCustomEvent } from '@utils/logging/logging-utils';

const logUnsupportedCardType =
  () =>
  (_dispatch: AppDispatch, getState: AppGetState): void => {
    const formId = CARD_DETAILS_FORM_ID;
    const cardNumber = getState().form?.[formId]?.values?.cardNumber ?? '';
    const binRange = cardNumber.replace(' ', '').substring(0, 6);

    sendNewRelicCustomEvent('unsupportedBinRange', { binRange });
  };

export default logUnsupportedCardType;
